var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k-textarea",class:{ 'k-textarea--autogrow': _vm.autogrow }},[_c('textarea',_vm._g({ref:"inputField",staticClass:"k-textarea__input",class:{
      'k-textarea__input--bright': _vm.bright,
      'k-textarea__input--disabled': _vm.disabled
    },attrs:{"placeholder":_vm.placeholder,"maxlength":_vm.maxLength,"disabled":_vm.disabled},domProps:{"value":_vm.value}},_vm.inputListeners)),_vm._v(" "),(_vm.autogrow)?_c('div',{staticClass:"k-textarea__spacer"},[_vm._v(_vm._s(`${_vm.value}\n`))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }